module.exports = __webpack_public_path__ + "static/media/slack_logo.1651f280.svg";